module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', {
    attrs: {
      "align-center": "",
      "justify-center": "",
      "row": "",
      "fill-height": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm8": "",
      "md4": ""
    }
  }, [_c('v-card', {
    staticClass: "elevation-12"
  }, [_c('v-toolbar', {
    staticClass: "darken-3",
    attrs: {
      "dark": "",
      "color": "info"
    }
  }, [_c('v-toolbar-title', [_vm._v("Login form")]), _vm._v(" "), _c('v-spacer')], 1), _vm._v(" "), _c('v-card-text', [_c('v-form', {
    attrs: {
      "id": "loginForm"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.checkLogin.apply(null, arguments)
      }
    }
  }, [_c('v-text-field', {
    attrs: {
      "prepend-icon": "person",
      "id": "userLogin",
      "placeholder": "login"
    },
    model: {
      value: (_vm.userLogin),
      callback: function($$v) {
        _vm.userLogin = $$v
      },
      expression: "userLogin"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "prepend-icon": "lock",
      "id": "userPassword",
      "placeholder": "password",
      "type": "password"
    },
    model: {
      value: (_vm.userPassword),
      callback: function($$v) {
        _vm.userPassword = $$v
      },
      expression: "userPassword"
    }
  })], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "darken-3",
    attrs: {
      "form": "loginForm",
      "type": "submit",
      "color": "info"
    }
  }, [_vm._v("Login")])], 1)], 1)], 1), _vm._v(" "), _c('AppMainDialog', {
    attrs: {
      "open": _vm.dialogOpen,
      "message": _vm.dialogMessage
    },
    on: {
      "closedialog": function($event) {
        _vm.dialogOpen = false
      }
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d731e878","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Login.vue
// module id = 1002
// module chunks = 1